import { Pipe, PipeTransform } from '@angular/core';
import { ObjectUtils } from '../utils';

@Pipe({
  name: 'getFieldValue',
  standalone: true,
  pure: true,
})
export class GetFieldValuePipe implements PipeTransform {
  transform(object?: any, fieldName?: string): any {
    return ObjectUtils.getPropertyValue(object, fieldName);
  }
}
